// @flow

import { toast } from "react-toastify";
import fileDownload from "js-file-download";
import I18n from "../i18n/I18n";
import Types from "../actions/Types";
import Actions from "../actions/Creators";
import { put, call, takeLatest } from "redux-saga/effects";

export default (api: Object) => {
  /* Get reports */
  function* getReports(action) {
    try {
      const response = yield call(api.reports.getReports, action.query);

      if (
        response.ok &&
        response.data &&
        {}.hasOwnProperty.call(response, "data")
      ) {
        yield put(Actions.getReportsSuccess(response.data));
      } else {
        yield put(Actions.getReportsFailure(response.error || "Error"));
        toast(response.data.error || "Error", {
          type: "error",
          className: "errorClass"
        });
      }
    } catch (error) {
      yield put(Actions.getReportsFailure(error));
    }
  }
  function* watchGetReports(): Generator<void, void, void> {
    yield takeLatest(Types.GET_REPORTS, getReports);
  }

  function* exportReports(action) {
    try {
      const response = yield call(
        api.reports.postReports,
        action.link,
        action.param
      );

      if (
        response.ok &&
        response.data &&
        {}.hasOwnProperty.call(response, "data")
      ) {
        yield put(Actions.exportReportsSuccess(response.data));
        fileDownload(response.data, `${action.name}.csv`);
        toast(
          I18n.getText(
            "reports.export-success",
            { name: action.name },
            "{name} Exported Successfully"
          ),
          {
            type: "success",
            className: "successClass"
          }
        );
      } else {
        yield put(Actions.exportReportsFailure(response.error || "Error"));
        toast(response.data.error || "Error", {
          type: "error",
          className: "errorClass"
        });
      }
    } catch (error) {
      yield put(Actions.exportReportsFailure(error));
    }
  }
  function* watchExportReports(): Generator<void, void, void> {
    yield takeLatest(Types.EXPORT_REPORTS, exportReports);
  }

  /* Get Sales */
  function* getSales(action) {
    try {
      const response = yield call(api.reports.getSales, action.query);

      if (
        response.ok &&
        response.data &&
        {}.hasOwnProperty.call(response, "data")
      ) {
        yield put(Actions.getSalesSuccess(response.data));
      } else {
        yield put(Actions.getSalesFailure(response.error || "Error"));
        toast(response.data.error || "Error", {
          type: "error",
          className: "errorClass"
        });
      }
    } catch (error) {
      yield put(Actions.getSalesFailure(error));
    }
  }
  function* watchGetSales(): Generator<void, void, void> {
    yield takeLatest(Types.GET_SALES, getSales);
  }

  /* Get Sales */
  function* getSalesStatus(action) {
    try {
      const response = yield call(api.reports.getSalesStatus, action.query);

      if (
        response.ok &&
        response.data &&
        {}.hasOwnProperty.call(response, "data")
      ) {
        yield put(Actions.getSalesStatusSuccess(response.data));
      } else {
        yield put(Actions.getSalesStatusFailure(response.error || "Error"));
      }
    } catch (error) {
      yield put(Actions.getSalesStatusFailure(error));
    }
  }
  function* watchGetSalesStatus(): Generator<void, void, void> {
    yield takeLatest(Types.GET_SALES_STATUS, getSalesStatus);
  }

  /* Get SalesItem */
  function* getSalesItemDetails(action) {
    try {
      const response = yield call(api.reports.getSalesItemDetails, action.query);

      if (
        response.ok &&
        response.data &&
        {}.hasOwnProperty.call(response, "data")
      ) {
        yield put(Actions.getSalesItemDetailsSuccess(response.data));
      } else {
        yield put(Actions.getSalesItemDetailsFailure(response.error || "Error"));
        toast(response.data.error || "Error", {
          type: "error",
          className: "errorClass"
        });
      }
    } catch (error) {
      yield put(Actions.getSalesItemDetailsFailure(error));
    }
  }
  function* watchGetSalesItemDetails(): Generator<void, void, void> {
    yield takeLatest(Types.GET_SALES_ITEM_DETAILS, getSalesItemDetails);
  }

  return {
    watchGetReports,
    watchExportReports,
    watchGetSales,
    watchGetSalesItemDetails,
    watchGetSalesStatus
  };
};



// WEBPACK FOOTER //
// ./src/sagas/ReportsSaga.js